export type ActivatePayload = { customer_id: string; postal_code: string; email: string };
export type SetCredentialsPayload = { activation_token: string; email: string; password: string; confirm: string };
export type LoginPayload = { email: string; password: string };
export type ContextAddPayload = { customer_id: string; postal_code: string };
export type ContextSwitchPayload = { customer_id: string };

export const Schemas = {
  activate: {
    safeParse(v: any) {
      const ok = typeof v?.customer_id === 'string' && v.customer_id.trim() && typeof v?.postal_code === 'string' && v.postal_code.trim()
        && typeof v?.email === 'string' && /@/.test(v.email);
      return ok ? { success: true, data: v as ActivatePayload } : { success: false } as const;
    }
  },
  setCredentials: {
    safeParse(v: any) {
      const ok = typeof v?.activation_token === 'string' && v.activation_token.trim()
        && typeof v?.email === 'string' && /@/.test(v.email)
        && typeof v?.password === 'string' && v.password.length >= 8
        && typeof v?.confirm === 'string' && v.confirm.length >= 8
        && v.password === v.confirm;
      return ok ? { success: true, data: v as SetCredentialsPayload } : { success: false, error: { issues: [{ message: 'Please provide valid details' }] } } as const;
    }
  },
  login: {
    safeParse(v: any) {
      const ok = typeof v?.email === 'string' && /@/.test(v.email) && typeof v?.password === 'string' && v.password;
      return ok ? { success: true, data: v as LoginPayload } : { success: false } as const;
    }
  },
  contextAdd: {
    safeParse(v: any) {
      const ok = typeof v?.customer_id === 'string' && v.customer_id.trim() && typeof v?.postal_code === 'string' && v.postal_code.trim();
      return ok ? { success: true, data: v as ContextAddPayload } : { success: false } as const;
    }
  },
  contextSwitch: {
    safeParse(v: any) {
      const ok = typeof v?.customer_id === 'string' && v.customer_id.trim();
      return ok ? { success: true, data: v as ContextSwitchPayload } : { success: false } as const;
    }
  }
}; 